var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"relative flex items-center justify-center w-full h-16 font-semibold text-white bg-blue-600 border-b-4 border-blue-800 rounded-lg shadow focus:outline-none text-shadow"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }